import {
	Col,
	InputGroup,
	Row,
	Form as BForm,
	Button,
	Spinner,
} from "@themesberg/react-bootstrap";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { getSiteConfiguration } from "../../utils/apiCalls";
import { BoxContainer, NoDataContainer } from "./style";
import { InlineLoader } from "../Preloader";
import { adminProfileSchema, adminSiteConfigSchema } from "./schema";
import { useDispatch, useSelector } from "react-redux";
import { getLanguagesStart } from "../../store/redux-slices/languages";
import Select from "react-select";

const SiteConfig = ({
	setEditable,
	editable,
	updateData,
	constant,
	loading,
	isSiteConfigurationsEdit
}) => {
	const dispatch = useDispatch();
	const [details, setDetails] = useState(null);
	const [isGetLoading, setIsGetLoading] = useState(false);
	const [formLanguage, setFormLanguage] = useState([]);
	const { languages } = useSelector((state) => state.languages);

	useEffect(() => {
		setIsGetLoading(true);
		dispatch(getLanguagesStart({ limit: "", pageNo: "", name: "" }));
		async function fetchData() {
			await getSiteConfiguration().then((res) => {
				setDetails(res?.data?.data?.siteInformation);
				setIsGetLoading(false);
			});
		}
		fetchData();
	}, []);

	useEffect(() => {
		if (details && details[1]?.value?.languages) {
			const sectectedArr = [];
			Object.keys(details[1]?.value?.languages).map((key) => {
				let label = {};
				label["label"] = details[1]?.value?.languages[key];
				label["value"] = key;
				sectectedArr.push(label);
			});
			setFormLanguage(sectectedArr);
		}
	}, [details]);

	const languageOptions = languages?.rows?.map(({ code, languageName }) => ({
		value: code,
		label: languageName,
	}));

	const handleCancel = (resetForm) => {
		resetForm();
		setEditable(false);
	};

	return (
		<BoxContainer className="FormsBg">
			{isGetLoading ? (
				<NoDataContainer>
					<InlineLoader />
				</NoDataContainer>
			) : (
				<>
					{details && (
						<Formik
							enableReinitialize
							initialValues={{
								name: details[1]?.value.name || "",
								url: details[1]?.value.url || "",
								supportEmail: details[1]?.value.supportEmail || "",
								sendgridEmail: details[0]?.value.SENDGRID_EMAIL || "",
								sendgridKey: details[0]?.value.SENDGRID_API_KEY || "",
								logo: details[1]?.value?.logo || null,
								lang: formLanguage || null,
								maintenance: details[1]?.value.maintenance ? true : false,
							}}
							validationSchema={adminSiteConfigSchema}
							onSubmit={(formValues) => {
								let label = {};
								if (formValues?.lang) {
									const formdata = formValues?.lang.map((obj) => {
										label[obj.value] = obj.label;
									});
								}
								updateData({
									...formValues,
									lang: label && JSON.stringify(label),
								});
							}}
						>
							{({
								values,
								touched,
								errors,
								handleChange,
								handleSubmit,
								handleBlur,
								setFieldValue,
								resetForm,
							}) => {
								// console.log("errorsvalues", {values, details});
								return (
									<Form>
										<Row>
											{details &&
												constant.map(
													({ key, value, subValue, edit, type }, index) => {
														return (
															<Col
																md={6}
																sm={12}
																className="mb-3"
																key={index}
																hidden={
																	details?.adminRoleId === 1 ||
																		details?.superRoleId === 1
																		? key === "Group"
																		: false
																}
															>
																<div>
																	<label className="form-label">
																		{key || "N/A"}
																	</label>
																	<span className="mb-0">
																		{key === "Status" ? (
																			details[value] ? (
																				"Active"
																			) : (
																				"In-Active"
																			)
																		) : subValue ? (
																			<p>{details?.[value]?.[subValue]}</p>
																		) : (
																			<>
																				<InputGroup>
																					<BForm.Control
																						type={ type || "text"}
																						name={value}
																						value={values?.[value]}
																						disabled={!edit || !editable}
																						onChange={handleChange}
																						onBlur={handleBlur}
																					/>
																				</InputGroup>

																				<ErrorMessage
																					component="div"
																					name={value}
																					className="text-danger"
																				/>
																			</>
																		)}
																	</span>
																</div>
															</Col>
														);
													}
												)}
											{/* <Col md={6} sm={12} className='mb-3' hidden={(details?.adminRoleId === 1 || details?.superRoleId === 1)}>
													<BForm.Label className='form-label'>Allowed Languages
													</BForm.Label>
													<Select
														isMulti={true}
														name='lang'
														value={values?.lang}
														isDisabled={!editable}
														onChange={(option) => {
															let isExist = option.find((op) => op.value == "EN");
															if (!isExist) {
																option.unshift({ label: 'English', value: 'EN' })
															}
															setFieldValue('lang', option)
														}}
														options={languageOptions}
														className={
															'basic-multi-select' && touched.lang && errors.lang
																? 'border border-danger'
																: ''
														}
														classNamePrefix='select'
													/>
													<ErrorMessage
														component='div'
														name='lang'
														className='text-danger'
													/>
												</Col> */}
											<Col md={6} sm={12} className='mb-3' hidden={(details?.adminRoleId === 1 || details?.superRoleId === 1)}>
													<BForm.Label className='form-label'>Site Logo
													</BForm.Label>

													<Col xs={12}>
														<BForm.Control
															type='file'
															name='logo'
															// accept="image/*"
															disabled={!editable}
															onChange={(event) => {
																const file = event.target.files[0];
																setFieldValue('logo', file || null);
															}}
															onBlur={handleBlur}
														/>

														<ErrorMessage
															component='div'
															name='logo'
															className='text-danger'
														/>
													</Col>

													

													{
  values?.logo && (
    <Col>
      <img
        alt="not found"
        className="mt-2"
        style={{ maxWidth: '300px', maxHeight: '300px' }}
        src={
          typeof values.logo === 'string'
            ? values.logo        // if already a URL
            : URL.createObjectURL(values.logo) // if a File object
        }
      />
    </Col>
  )
}

											
												</Col>

											{/* <Col md={6} sm={12} className='mb-3' hidden={(details?.adminRoleId === 1 || details?.superRoleId === 1)}>
													<BForm.Label>
														Maintenance
													</BForm.Label>
													<BForm.Check
														name='maintenance'
														type='switch'
														disabled={!editable}
														onChange={handleChange}
														onBlur={handleBlur}
														checked={values.maintenance}
													/>
													<ErrorMessage
														component='div'
														name='maintenance'
														className='text-danger'
													/>
												</Col> */}
											{/* <Row className='mt-3'> */}

											{/* </Row> */}
										</Row>
										<div className="mt-4 mb-3 d-flex gap-2">
											<Button
												variant="m-1 btn btn-primary"
												onClick={handleSubmit}
												className="ml-2"
												hidden={!editable}
											>
												Submit
												{loading && (
													<Spinner
														as="span"
														animation="border"
														size="sm"
														role="status"
														aria-hidden="true"
													/>
												)}
											</Button>
											<Button
												variant="m-1 btn btn-secondary"
												onClick={() => handleCancel(resetForm)}
												className="ml-2"
												hidden={!editable}
											>
												Cancel
											</Button>
										</div>
									</Form>
								);
							}}
						</Formik>
					)}
					{isSiteConfigurationsEdit && <div className="text-right">
						<Button
							hidden={editable}
							variant="m-1 btn btn-primary"
							onClick={() => {
								setEditable(true);
							}}
						>
							Edit
						</Button>
					</div>}
				</>
			)}
		</BoxContainer>
	);
};

export default SiteConfig;
